import { usePage } from "@inertiajs/react"
import { useEffect } from "react"
import FlashMessages from "./FlashMessages"
import MantineThemeProvider from "./MantineThemeProvider"
import ThemeSwitcher from "./ThemeSwitcher"

export default function AppShell({ children }) {
  const page = usePage()
  const app = page.props.app || {}

  useEffect(() => {
    if (!app.csrfToken) return

    const [csrfMetaTag, ...duplicates] = document.querySelectorAll('meta[name="csrf-token"]')
    const metaTag = csrfMetaTag || document.head.appendChild(document.createElement("meta"))

    metaTag.setAttribute("name", "csrf-token")
    metaTag.setAttribute("content", app.csrfToken)
    duplicates.forEach((duplicate) => duplicate.remove())
  }, [app.csrfToken, page.url])

  return (
    <MantineThemeProvider>
      <FlashMessages flash={page.flash || {}} labels={app.flash || {}} placement={page.props.admin ? "admin" : "default"} />
      {children}
      {page.props.admin ? null : <ThemeSwitcher labels={app.theme || {}} />}
    </MantineThemeProvider>
  )
}
